import PropTypes from 'prop-types';

export const PlaceActionPropType = PropTypes.shape({
  name: PropTypes.string,
  uri: PropTypes.string,
  providerType: PropTypes.string,
  isEditable: PropTypes.bool,
  placeActionType: PropTypes.string,
  isPreferred: PropTypes.bool,
  createTime: PropTypes.string,
  updateTime: PropTypes.string,
});

export const ProviderEntityAttributesPropType = PropTypes.shape({
  id: PropTypes.number,
  serviceSetting: PropTypes.number,
  location: PropTypes.number,
  objectId: PropTypes.number,
  sourceId: PropTypes.number,
  syncedAt: PropTypes.string,
  status: PropTypes.string,
  contentType: PropTypes.number,
  attributes: PropTypes.oneOfType([PlaceActionPropType]),
});
